export const WHITE_LABEL_CNAME_TARGET =
  process.env.WHITE_LABEL_CNAME_TARGET?.trim().toLowerCase().replace(/\.$/, "") ||
  "white-label.scaffer.co.uk";

export const TXT_VERIFICATION_PREFIX = "_scaffer-verification";

export const DOMAIN_STATUSES = [
  "none",
  "pending_dns",
  "verifying",
  "verified",
  "ssl_pending",
  "active",
  "failed",
] as const;

export type DomainStatus = (typeof DOMAIN_STATUSES)[number];

export const SSL_STATUSES = ["none", "pending", "active", "failed"] as const;

export type SslStatus = (typeof SSL_STATUSES)[number];

/** Hostnames reserved for the platform — never resolve as tenant portals. */
export const RESERVED_SCAFFOLDER_SUBDOMAINS = new Set([
  "www",
  "app",
  "api",
  "admin",
  "mail",
  "smtp",
  "white-label",
  "staging",
  "dev",
]);

export const TENANT_COMPANY_ID_HEADER = "x-company-id";
export const TENANT_HOST_HEADER = "x-tenant-host";
export const TENANT_CLIENT_ID_HEADER = "x-tenant-client-id";
